import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./attendanceTour.css";

export function startAttendancePageTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Tour giúp bạn nắm nhanh thao tác chính của trang Điểm danh: chọn chế độ, lọc và mở lớp để điểm danh.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    {
      selector: '[data-tour="attendance-header"]',
      title: "Khu vực tiêu đề",
      description: "Nơi hiển thị tên trang và cụm nút hướng dẫn.",
      side: "bottom",
    },
    {
      selector: '[data-tour="attendance-header-guides"]',
      title: "Cụm nút hướng dẫn",
      description: "Mở tour nhanh hoặc tài liệu HTML của module điểm danh.",
      side: "left",
    },
    {
      selector: '[data-tour="attendance-tabs"]',
      title: "Chuyển chế độ",
      description:
        "Đổi giữa điểm danh hàng ngày, lịch sử liên hệ, và báo cáo theo lớp (bấm lớp để xem chi tiết HV, xuất Excel).",
      side: "bottom",
    },
    {
      selector: '[data-tour="attendance-filter"]',
      title: "Bộ lọc ngày học",
      description: "Lọc theo ngày, từ khóa, cơ sở và đơn vị để tìm đúng lớp cần điểm danh.",
      side: "bottom",
    },
    {
      selector: '[data-tour="attendance-classes"]',
      title: "Danh sách lớp trong ngày",
      description: "Bấm vào từng thẻ lớp để mở modal điểm danh chi tiết.",
      side: "top",
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert("Không tìm thấy vùng để chạy hướng dẫn. Hãy tải lại trang và thử lại.");
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "attendance-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
